import dayjs from 'dayjs';

export const API_DATETIME = 'YYYY-MM-DD HH:mm:ss';

export const emptyCouponForm = () => ({
  store_id: '',
  coupon_code: '',
  offer_name_en: '',
  offer_name_ar: '',
  description: '',
  description_ar: '',
  offer_value_type: 'percentage',
  offer_value: '',
  minimum_purchase_amount: '',
  max_discount_amount: '',
  from_datetime: null,
  to_datetime: null,
  is_first_order: false,
  status: true,
  auto_apply: false
});

export function formatApiDatetime(value) {
  if (!value) return null;
  return dayjs(value).format(API_DATETIME);
}

export function cleanCouponCode(code) {
  if (!code) return '';
  return String(code).toUpperCase().trim();
}

export function validateCouponCodeFormat(code) {
  const cleaned = cleanCouponCode(code);
  if (!cleaned) return 'Coupon code is required.';
  const regex = /^[A-Z0-9_-]+$/;
  if (!regex.test(cleaned)) {
    return 'Coupon code can only contain letters, numbers, underscores, and hyphens.';
  }
  return null;
}

export function validateCouponForm(form) {
  const errors = {};

  if (!form.store_id) {
    errors.store_id = 'Store selection is required.';
  }

  const codeErr = validateCouponCodeFormat(form.coupon_code);
  if (codeErr) errors.coupon_code = codeErr;

  if (!form.offer_name_en || !form.offer_name_en.trim()) {
    errors.offer_name_en = 'Offer name (EN) is required.';
  }

  const valNum = parseFloat(form.offer_value);
  if (isNaN(valNum) || valNum <= 0) {
    errors.offer_value = 'Discount value must be greater than zero.';
  } else if (form.offer_value_type === 'percentage' && valNum > 100) {
    errors.offer_value = 'Percentage discount cannot exceed 100%.';
  }

  if (form.minimum_purchase_amount !== '' && form.minimum_purchase_amount !== null) {
    const minPur = parseFloat(form.minimum_purchase_amount);
    if (isNaN(minPur) || minPur < 0) {
      errors.minimum_purchase_amount = 'Minimum purchase cannot be negative.';
    }
  }

  if (form.max_discount_amount !== '' && form.max_discount_amount !== null) {
    const maxDisc = parseFloat(form.max_discount_amount);
    if (isNaN(maxDisc) || maxDisc <= 0) {
      errors.max_discount_amount = 'Maximum discount amount must be greater than zero.';
    }
  }

  if (!form.from_datetime) {
    errors.from_datetime = 'Start date/time is required.';
  }

  if (!form.to_datetime) {
    errors.to_datetime = 'End date/time is required.';
  } else if (form.from_datetime && (dayjs(form.to_datetime).isBefore(dayjs(form.from_datetime)) || dayjs(form.to_datetime).isSame(dayjs(form.from_datetime)))) {
    errors.to_datetime = 'End date/time must be strictly after start date/time.';
  }

  return errors;
}

export function buildCouponPayload(form) {
  return {
    store_id: form.store_id,
    offer_type: 'coupon',
    coupon_code: cleanCouponCode(form.coupon_code),
    offer_name_en: form.offer_name_en.trim(),
    offer_name_ar: (form.offer_name_ar || '').trim(),
    description: (form.description || '').trim(),
    description_ar: (form.description_ar || '').trim(),
    offer_value_type: form.offer_value_type,
    offer_value: parseFloat(form.offer_value) || 0,
    minimum_purchase_amount: form.minimum_purchase_amount !== '' && form.minimum_purchase_amount !== null ? parseFloat(form.minimum_purchase_amount) : 0,
    max_discount_amount: form.max_discount_amount !== '' && form.max_discount_amount !== null ? parseFloat(form.max_discount_amount) : null,
    from_datetime: formatApiDatetime(form.from_datetime),
    to_datetime: formatApiDatetime(form.to_datetime),
    is_first_order: !!form.is_first_order,
    status: form.status !== undefined ? !!form.status : true,
    auto_apply: !!form.auto_apply
  };
}

export function buildFormFromCoupon(coupon) {
  if (!coupon) return emptyCouponForm();
  return {
    store_id: coupon.store_id ?? coupon.storeId ?? coupon.store_uuid ?? coupon.Store?.store_id ?? coupon.store?.store_id ?? coupon.Store?.id ?? coupon.store?.id ?? '',
    coupon_code: coupon.coupon_code || '',
    offer_name_en: coupon.offer_name_en || '',
    offer_name_ar: coupon.offer_name_ar || '',
    description: coupon.description || '',
    description_ar: coupon.description_ar || '',
    offer_value_type: coupon.offer_value_type || 'percentage',
    offer_value: coupon.offer_value ?? '',
    minimum_purchase_amount: coupon.minimum_purchase_amount ?? '',
    max_discount_amount: coupon.max_discount_amount ?? '',
    from_datetime: coupon.from_datetime ? dayjs(coupon.from_datetime) : null,
    to_datetime: coupon.to_datetime ? dayjs(coupon.to_datetime) : null,
    is_first_order: !!coupon.is_first_order,
    status: coupon.status !== undefined ? !!coupon.status : true,
    auto_apply: !!coupon.auto_apply
  };
}
